<script lang="ts" module>
  import type { Snippet } from 'svelte';
  import { z } from 'zod';
  import { ButtonTheme } from '$components/Button/BlockButton.svelte';
  import cloneDeep from 'lodash/cloneDeep';

  export const CareersLandingThemeSchema = z.object({
    button: ButtonTheme.optional(),
    jobLocation: JobLocationTheme.optional()
  });

  export type CareersLandingTheme = z.infer<typeof CareersLandingThemeSchema>;

  const LightTheme = {
    button: {
      primaryButton: {
        default: { backgroundColor: '#000000', foregroundColor: 'white' },
        hoverFocus: { backgroundColor: 'white', foregroundColor: 'black' },
        active: { backgroundColor: '#000000', foregroundColor: 'white' }
      }
    },
    jobLocation: {
      color: 'black'
    }
  };

  const DarkTheme = cloneDeep(LightTheme);
</script>

<script lang="ts">
  import { themeStyleVars } from '$lib/pages/theme';
  import { JobLocationTheme } from '../[id]/components/JobLocation.svelte';

  interface Props {
    theme?: 'light' | 'dark';
    children?: Snippet;
  }

  let { theme = 'light', children }: Props = $props();

  let styleVars = $derived(themeStyleVars(theme === 'light' ? LightTheme : DarkTheme));
</script>

<div style={styleVars}>
  {@render children?.()}
</div>
